/**
 * Email Container is the auto-sizer to fit the email view onto the screen correctly
 *
 * This should be used to wrap around the mail email subject and body parts.
 */

import React, { HTMLAttributes } from "react";
import styled from "styled-components";
import classnames from "classnames";
import AutoSizer from "react-virtualized-auto-sizer";

export type EmailContainerProps = HTMLAttributes<HTMLDivElement> & {
    children: React.ReactNode
}

const StyledEmailContainer = styled.div`
    overflow-y: auto;
`;

const EmailContainer = ({
    children,
    className = "p-2",
    style,
    ...rest
} : Readonly<EmailContainerProps>) => (
    <AutoSizer>
        {({ height, width }) => (
            <StyledEmailContainer className={classnames(className)} style={{ height, width }} {...rest}>
                {children}
            </StyledEmailContainer>
        )}
    </AutoSizer>
)

export default EmailContainer;